'use strict';

import './GenericLandingAboveFold.less';

import React from 'react';

import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import Animation from 'ck-core-client/source/ui/Animation';
import CloudImageFrame from '../../ui/system/CloudImageFrame';
import PropTypes from 'prop-types';
export class GenericLandingAboveFold extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	componentDidMount() {}

	render() {
		return (
			<div className="GenericLandingAboveFold">
				<div className="maxWidthContentWrapper">
					<div className="left">
						<h1 className="title" dangerouslySetInnerHTML={{ __html: this.props.title }}></h1>

						<h2 className="subtitle">{this.props.subtitle}</h2>

						<div className="buttonWrapper">{this.props.button}</div>
					</div>
					<div className="right">
						<CloudImageFrame
							imageName={this.props.imageName}
							videoFallbackName={this.props.videoFallbackName}
							videoName={this.props.videoName}
							videoId={'169676431'}
						/>
					</div>
				</div>

				<div className="trustpilotTopBox">
					<a href="https://uk.trustpilot.com/review/codekingdoms.com">
						<div className="scoreName">Excellent</div>
						<ReactCKImage
							name="trustpilot-stars-summary"
							forceImgTag={true}
							extraClasses={['stars']}
						/>
					</a>

					<a href="https://uk.trustpilot.com/review/codekingdoms.com">
						<div className="summary">See all our reviews on </div>{' '}
						<ReactCKImage name="trustpilot-score" forceImgTag={true} extraClasses={['logo']} />
					</a>
				</div>

				<Animation name="MinecraftTopSectionDesktop" loop={true} />

				<div className="arrowAnimation">
					<div className="arrow"></div>
				</div>
			</div>
		);
	}
}

GenericLandingAboveFold.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	button: PropTypes.object,
	imageName: PropTypes.string,
	videoFallbackName: PropTypes.string,
	videoName: PropTypes.string
};
